import React from "react";
import LoadingWrapper from "./LoadingWrapper";
import "./App.css";

function App() {
	return (
		<div className="App">
			<LoadingWrapper />
		</div>
	);
}

export default App;
